import React from 'react';
import AvailableBalance from './AvailableBalance';
import SpentThisMonth from './SpentThisMonth';
import LastTopUp from './LastTopUp';
import LowBalanceAlert from './LowBalanceAlert';
import AddFunds from './AddFunds';
import BalanceHistory from './BalanceHistory';
import Footer from './Footer';

import styles from './style.module.scss';

const WalletDashboard = () => {
  return (
    <div className={styles.dashboard} data-testid="walletDashboard">
      <div className={styles.statRow}>
        <AvailableBalance />
        <SpentThisMonth />
        <LastTopUp />
      </div>
      <div className={styles.actionRow}>
        <LowBalanceAlert />
        <AddFunds />
      </div>
      <BalanceHistory />
      <Footer />
    </div>
  );
};

export default WalletDashboard;
